import { createContext, useContext, useMemo, useState } from 'react';
import { loadPractitionerSidebarState } from 'utils/storage';

interface PractitionerSidebarContextProps {
  children: React.ReactNode;
}

const PractitionerSidebarContext = createContext<{
  isPractitionerCollapsed: boolean;
  setIsPractitionerCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
} | null>(null);

const PractitionerSidebarProvider = ({
  children,
}: PractitionerSidebarContextProps) => {
  const [isPractitionerCollapsed, setIsPractitionerCollapsed] = useState(() =>
    loadPractitionerSidebarState()
  );

  const value = useMemo(
    () => ({
      isPractitionerCollapsed,
      setIsPractitionerCollapsed,
    }),
    [isPractitionerCollapsed]
  );

  return (
    <PractitionerSidebarContext.Provider value={value}>
      {children}
    </PractitionerSidebarContext.Provider>
  );
};

const usePractitionerSidebar = () => {
  const context = useContext(PractitionerSidebarContext);
  if (!context) {
    throw new Error(
      'useVersion must be used within PractitionerSidebarProvider'
    );
  }
  return context;
};

export { PractitionerSidebarProvider, usePractitionerSidebar };
